'use strict';

import {invitationModel} from "../../models/invitationmodel.js";

export class InvitationAppFormCtrl
{
	$scope;
	$filter;
	$mdDialog;
	jsDataService;
	nodeList = [];
	navigationList = [];
	
	constructor($scope, $filter, $mdDialog, jsDataService){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.$mdDialog = $mdDialog;
		this.jsDataService = jsDataService;
		let strNodeList = jsDataService.get('structureTreeNodeList', false);
		if(false !== strNodeList){
			this.nodeList = strNodeList;
			this.navigationList = jsDataService.get('structureNavigationList', false);
			let idx = jsDataService.get('structureCurrentIndex', false);
			if(false !== idx){
				this.currentIndex = idx;
			}
		}
		else{
			this.makeStructureList(jsDataService.get('structureTree', {}));
			jsDataService.set('structureTreeNodeList', this.nodeList);
			jsDataService.set('structureNavigationList', this.navigationList);
			if(this.currentIndex > -1){
				jsDataService.set('structureCurrentIndex', this.currentIndex);
			}
		}

	}

	makeStructureList(tree){
		for(let nodeKey in tree){
			let strTree;
			if(tree[nodeKey].haschilds){
				strTree = tree[nodeKey].childs;
				delete tree[nodeKey].childs;
			}
			this.nodeList.push(tree[nodeKey]);
			if(this.isAction(tree[nodeKey])){
				this.navigationList.push(tree[nodeKey]);
			}
			if(tree[nodeKey].haschilds){
				this.makeStructureList(strTree);
			}
//			else{
//				this.navigationList.push(tree[nodeKey]);
//			}
			if(typeof(tree[nodeKey].current) !== 'undefined' && tree[nodeKey].current){
				this.currentIndex = this.navigationList.length - 1;
			}
		}
	}

	nodeTitleFormated(node){
		let idt = '';
		let nr = '';
		const tim = 8;
//		const sp = '&nbsp;';
//		if(node.level > 1){
//			idt = sp.repeat(tim * (parseInt(node.level) - 1));
//		}
		if(node.numbered == 1 && node.number !== ''){
			nr = node.number + ' ';
		}
		return idt + nr + node.title;
	}

	isAction(node){
		return ((typeof(node.has_fields) !== 'undefined' && node.has_fields) || (typeof(node.has_instructions) !== 'undefined' && node.has_instructions));
	}
	
	actionEditFields(ev, node){
		const rootUrl = this.jsDataService?.data?.root_url ?? '';
		this.$scope.goUrl(rootUrl + node.edit_url);
	}

	actionPreviewFields(ev, node){
		const rootUrl = this.jsDataService?.data?.root_url ?? '';
		this.$scope.goUrl(rootUrl + node.preview_url);
	}

	actionActive(ev, item){
		if(this.jsDataService.get('toggleUrl')){
			this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('toggleUrl'),
				method: 'POST',
				data: {
					id: item.id,
					active: !item.active
				}
			}).then((response) => {
				if(response.data.success){
					item.active = response.data.active;
				}
			});
	   }
	}

	actionEdit(ev, item){
		this.itemEditor(ev, item);
	}

	itemEditor(ev, item){
		this.$mdDialog.show({
			controller: ["$scope", "$filter", "$mdDialog", "jsDataService", "item", this.itemEditorDialogCtrl],
			templateUrl: 'invitations/appform_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				item: item
			}
		}).then((appitem) => {
//			console.log(item)
			if(this.jsDataService.get('saveUrl')){
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('saveUrl'),
					method: 'POST',
					data: appitem
				}).then((response) => {
					if(response.data.success && typeof(response.data.item) !== 'undefined'){
						if(item.id > 0){
							item = angular.extend(item, response.data.item);
						}
					}
				}, () => {});
			}
			else{
				console.log('no url ', this.jsDataService.get('saveUrl'));
			}
		}, () => {});
	}

	itemEditorDialogCtrl($scope, $filter, $mdDialog, jsDataService, item){
		$scope.item = angular.copy(item);

		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function(){
			$mdDialog.hide($scope.item);
		};
	}
}